import { 
    Translation, 
    TranslocoModule, 
    TranslocoService, 
    provideTransloco
} from '@ngneat/transloco';
import { NgModule, isDevMode, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@src/environments/environment';
import { TranslocoHttpLoader } from '@app/core/transloco/transloco.http-loader';

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        // Use provideTransloco to configure Transloco with all required providers
        provideTransloco({
            config: {
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English'
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish'
                    }
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            },
            loader: TranslocoHttpLoader
        }),
        provideAppInitializer(() => {
        const initializerFn = ((translocoService: TranslocoService): any => (): Promise<Translation> => {
                const defaultLang = translocoService.getDefaultLang();
                translocoService.setActiveLang(defaultLang);
                return firstValueFrom(translocoService.load(defaultLang));
            })(inject(TranslocoService));
        return initializerFn();
      })
    ]
})
export class TranslocoCoreModule
{
}
